import React from "react"
import PropTypes from "prop-types"
import { DetectCompact, withRadium } from "higher-order-components"
import {
  ColumnGroup,
  Column,
  MyMazdaSummary,
  FixedBar,
  SpecificationList,
  HeadingBlock
} from "containers"
import { Button } from "components"

const OutletStoreSpecificationsBlock = (props) => {
  /**
   * @param {String} heading - Heading text.
   * @param {Object} vehicleProps - Vehicle properties.
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {Object} specifications - Specifications data object.
   * @returns {ReactElement} React Component
   */
  const {
    specifications, Interactive = "", heading = "", vehicleProps, compact
  } = props
  if (props.error) {
    return <div style={{ color: "red", textAlign: "center" }}>{props.error}</div>
  }
  return (
    <div>
      <ColumnGroup maxWidth={800}>
        <Column textAlignMobile="center" textAlign="center">
          <HeadingBlock
            margin
            preHeading={Interactive.replace("{nameplate}", vehicleProps.nameplate)}
            value={heading.replace("{nameplate}", vehicleProps.nameplate)} />
          <p
            style={{
              fontSize: "90%",
              color: "#939393",
              fontWeight: 200,
              lineHeight: 1.4
            }}>
            {vehicleProps.imageDisclaimer || "Image is for illustration purposes only"}
          </p>
          <img src={vehicleProps.imageSrc} alt={heading} style={{ maxWidth: "100%" }} />
          <MyMazdaSummary {...vehicleProps} style={{ padding: "2em 0" }} />
          {specifications && <SpecificationList specs={specifications.data.categories} />}
        </Column>
      </ColumnGroup>
      <FixedBar>
        <div style={{ padding: compact ? "0 1em" : ".5em 1.5em" }}>
          <Button
            label={"BACK"}
            href="javascript:history.back()"
            styleName="blackOutlined"
            display="inline" />
        </div>
      </FixedBar>
    </div>
  )
}

OutletStoreSpecificationsBlock.propTypes = {
  error: PropTypes.string,
  Interactive: PropTypes.string,
  heading: PropTypes.string,
  vehicleProps: PropTypes.shape({
    rego: PropTypes.string,
    vin: PropTypes.string,
    nameplate: PropTypes.string,
    grade: PropTypes.string,
    exterior: PropTypes.string,
    imageDisclaimer: PropTypes.string,
    drive: PropTypes.string,
    engine: PropTypes.string,
    transmission: PropTypes.string,
    modelCode: PropTypes.string,
    imageSrc: PropTypes.string
  }),
  specifications: PropTypes.shape({
    data: PropTypes.shape({
      categories: PropTypes.array,
      disclaimers: PropTypes.array
    })
  }),
  compact: PropTypes.bool
}

export default withRadium(DetectCompact())(OutletStoreSpecificationsBlock)

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */



// WEBPACK FOOTER //
// ./src/containers/outlet-store-specifications-block/index.jsx